document.addEventListener('DOMContentLoaded', function() {
  // Função para copiar cupom
  const copyButtons = document.querySelectorAll('.madesa-form-popup__copy-btn');

  copyButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      
      const textToCopy = this.getAttribute('data-copy-text');
      
      // Usar a Clipboard API
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(textToCopy).then(function() {
          // Mostrar feedback visual
          showCopyFeedback(button);
        }).catch(function(err) {
          // Fallback para o método antigo
          fallbackCopy(textToCopy, button);
        });
      } else {
        // Fallback para navegadores mais antigos
        fallbackCopy(textToCopy, button);
      }
    });
  });

  // Feedback visual ao copiar
  function showCopyFeedback(button) {
    const originalSvg = button.innerHTML;
    const copyText = button.closest('.madesa-form-popup__coupon-section').querySelector('.madesa-form-popup__copy-text');
    const originalText = copyText.textContent;
    
    // Mudar para checkmark e texto de feedback
    button.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 6L9 17L4 12" stroke="#28a745" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    
    copyText.textContent = 'Cupom copiado!';
    copyText.style.color = '#90ee90';
    
    // Restaurar ícone e texto original após 2 segundos
    setTimeout(function() {
      button.innerHTML = originalSvg;
      copyText.textContent = originalText;
      copyText.style.color = 'white';
    }, 2000);
  }

  // Fallback para copiar texto
  function fallbackCopy(text, button) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    
    try {
      document.execCommand('copy');
      showCopyFeedback(button);
    } catch (err) {
      console.error('Erro ao copiar:', err);
    }
    
    document.body.removeChild(textarea);
  }
});